export class Queries {
    validateToken = `query validateToken($token: String){
        validateToken(body: {
          token: $token
          }){
          body
        }
      }`;

    getUserOrganization = `query getUserOrganisation($userId: Int, $app: Int){
        getUserOrganisation(query:
           {
              userId: $userId,
              appId: $app
            }){
          data
        }
      }`;

    getProjectbyId = `query getProject($project_id : ID!){
        getProject(
        project_id:$project_id
        ){
          project_details
          project_mapping
      }
    }`;

    listAllProjects = `query listProjects($orgId: ID!, $status: ID!) {
        listProjects(
          org_id: $orgId
          status: $status
          ) {
         data
        }
      }
    `;

    listAllTeams = `
      query listTeams($envId: ID!, $status: ID!) {
        listTeams (
          org_id: $envId
          status: $status
        ){
          data
        }
      }
    `;

    getTeam = `
    //   query getTeam($team_id: ID!) {
    //     getTeam(team_id: $team_id) {
    //         data
    //     }
    //   }
    // `;

    getTeambyId = `query getTeam($team_id: ID!){
      getTeam(
      team_id:$team_id
      ){
        team_details
        team_mapping
    }
    }`;

    listAllUsers = `query getUsers($envId: ID) {
      getUsers(
        orgId: $envId
      ) {
        body
      }
    }`;

    listAllWorkshops = `query listWorkShop($envId: ID!, $status: ID) {
      listWorkShops(
        org_id: $envId
        status: $status
      ){
      data
    }
  }`;

    workshopById = `query getWorkShop($workshopId: ID!){
    getWorkShop(
    workshop_id:$workshopId
    ){
    data
  }

    }`;

    listAllActivities = `query listWorkShopActivities($workshopId: ID, $workshopDay: AWSDate, $status: ID!){
  listWorkShopsActivities(
      workshop_id: $workshopId
      workshop_day: $workshopDay
      status: $status
     ){
      data
    }
  }`;

    activityById = `query WorkShopActivity($activity_id: ID!){
    workShopActivity(
       activity_id : $activity_id
       ){
       data
     }
   }`;

    activityTag = `query listActivityTag($limit: ID!){
    listActivityTags(
        limit: $limit
        ){
        data
      }
    } `;

    getUserResponse = `query getUserWorkshopResponse($workshopId: ID, $activity_id: ID!) {
      getUserWorkshopResponse(
          workshop_id: $workshopId
          activity_id: $activity_id
          ){
          data
        }
      }`;

    getSprint = `query getSprint($project_id: ID!){
        getSprint(
          project_id:$project_id
        ){
          data
      }
    }`;

    getRevision = `query getRevision($sprint_id: ID!){
        getRevision(
          sprint_id:$sprint_id
        ){
          data
      }
    }`;

    getRisks = `query getRisks($project_id: Int) {
        getRisks(query: {project_id: $project_id, org_id: 0, risk_id: 0}) {
        data
      }
    }`;

    getAssumptions = `query getAssumptions($project_id: Int) {
    getAssumptions(query: {project_id: $project_id, org_id: 0, assumption_id: 0}) {
      data
    }
  }`;

    getIssues = `query getIssues($project_id: Int) {
    getIssues(query: {project_id: $project_id, org_id: 0, issue_id: 0}) {
    data
  }
}`;

    getDecisions = `query getDecisions($project_id: Int) {
  getDecisions(query: {project_id: $project_id, org_id: 0, decision_id: 0}) {
  data
}
}`;

    // stories module
    getProjectStories = `query getProjectStories($project_id: Int!, $story_id: String){ getProjectStories(query: {PROJECT_ID: $project_id, STORY_ID: $story_id}) {
  data
}}`;

    getProjectDeletedStories = `query getProjectDeletedStories($project_id: Int!){ getProjectDeletedStories(query: {PROJECT_ID: $project_id}) {
  data
}}`;

    // Project configuration data
    getProjectConfigNotifications = `query getProjectConfigData($project_id: Int, $org_id: Int) {
    getProjectConfigData(query: {project_id: $project_id, org_id: $org_id}) {
        data
    }
  }`;

    // get project releases data
    getProjectReleases = `
        query getProjectReleases($project_id: Int!, $org_id: Int!) {
            getProjectReleases(query: {PROJECT_ID: $project_id, orgId: $org_id}) {
        data
      }
    }`;
}
